import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import { Button, type ButtonProps } from '../Button/Button';

import styles from './FooterActions.module.scss';

export type FooterButtonProps = {
    key?: string | number;
    content: ReactNode;
} & Omit<ButtonProps, 'children'>;

type FooterActionProps = {
    className?: string;
    withSeparator?: boolean;
    buttons?: FooterButtonProps[];
    children?: ReactNode;
};

export const FooterActions = ({
    className,
    buttons,
    withSeparator,
    children
}: FooterActionProps): ReactElement | null => {
    if (!children && !buttons?.length) {
        return null;
    }
    return (
        <div
            className={classnames(
                styles.footerActions,
                { [styles.withSeparator]: withSeparator },
                className
            )}
        >
            {children}
            {buttons &&
                buttons.map(
                    (
                        {
                            className: footerButtonClassName,
                            content,
                            type,
                            key,
                            ...rest
                        }: FooterButtonProps,
                        idx: number
                    ) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Button
                            className={classnames(footerButtonClassName, styles.footerButton)}
                            type={type as never}
                            key={key ?? idx}
                            {...rest}
                        >
                            {content}
                        </Button>
                    )
                )}
        </div>
    );
};
